import { render, staticRenderFns } from "./TableAddSupplier.vue?vue&type=template&id=ca452ae6"
import script from "./TableAddSupplier.vue?vue&type=script&lang=js"
export * from "./TableAddSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports